import { store } from "./../../redux/";
import { call, put } from "redux-saga/effects";
import { url } from "./../../services/Url";
import CONSTANTS from "../../util/constants";
import APICallingService from "../../services/APICallingService";

const getLotsAPI = () => {
  return APICallingService.sendRequestForGet(url.getLot, (res) => {}, true);
};

function* getLots() {
  try {
    let s = store.getState();

    yield put({
      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE,
      payload: { value: true },
    });

    const response = yield call(getLotsAPI);
    if (response && response?.callBackStatus.toLowerCase() == "success") {
      yield put({
        type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT.GET_LOTS_API_SUCCESS,
        payload: { value: response.data },
      });
    } else {
      if (response && response != null && response.Status != 405) {
        alert("Failed to get lots ");
        yield put({
          type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT.GET_LOTS_API_SUCCESS,
          payload: { value: response?.callBackStatus },
        });
      }
    }
  } catch (e) {
    yield put({
      type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT.GET_LOTS_API_SUCCESS,
      payload: { value: "Failed" },
    });
  }
}

const getLotsByIdFun = (value) => {
  let urlGet = url.getDoors + value.id.toString();
  return APICallingService.sendRequestForGet(urlGet, (res) => {}, true);
};

function* getLotsById(action) {
  try {
    let s = store.getState();

    yield put({
      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE,
      payload: { value: true },
    });

    const response = yield call(getLotsByIdFun, action.payload.value);
    if (response && response?.callBackStatus.toLowerCase() == "success") {
      yield put({
        type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
          .GET_LOTSBYID_MANAGEMENT_API_SUCCESS,
        payload: { value: response.data },
      });
    } else {
      if (response && response != null && response.Status != 405) {
        alert("Failed to get lots data");
        yield put({
          type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
            .GET_LOTSBYID_MANAGEMENT_API_SUCCESS,
          payload: { value: response?.callBackStatus },
        });
      }
    }
  } catch (e) {
    yield put({
      type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
        .GET_LOTSBYID_MANAGEMENT_API_SUCCESS,
      payload: { value: "Failed" },
    });
  }
}

const createLotsAPI = (value) => {
  let payload = {
    lotName: value?.lotName,
    division_id: value?.division_id || 0,
  };

  return APICallingService.sendRequestForPostWithAuth(
    url.addLot,
    payload,
    false,
    (res) => {},
    true
  );
};

function* createLots(action) {
  try {
    let s = store.getState();

    yield put({
      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE,
      payload: { value: true },
    });

    const response = yield call(createLotsAPI, action.payload.value);

    if (response && response?.callBackStatus.toLowerCase() == "success") {
      alert("Lots no " + response.data.lot_id + " Added Successfully");

      yield put({
        type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
          .GET_LOTS_DIVISION_MANAGEMENT_API_CALL,
      });
      yield put({
        type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT.ADD_LOTS_API_SUCCESS,
        payload: { value: response?.callBackStatus },
      });
    } else {
      if (response && response != null && response.Status != 405) {
        alert("Failed to add lot");
        yield put({
          type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT.ADD_LOTS_API_SUCCESS,
          payload: { value: response?.callBackStatus },
        });
      }
    }
  } catch (e) {
    yield put({
      type: CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.ADD_LOTS_API_SUCCESS,
      payload: { value: "Failed" },
    });
  }
}

const editLotsAPI = (value) => {
  let urlEdit = url.editLot + value.lot_id;

  let payload = {
    lotName: value.lotName,
    is_active: value.is_active,
  };

  return APICallingService.sendRequestForPut(
    payload,
    urlEdit,
    (res) => {},
    true
  );
};

function* editLots(action) {
  try {
    let s = store.getState();

    yield put({
      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE,
      payload: { value: true },
    });

    const response = yield call(editLotsAPI, action.payload.value);

    if (response && response != null) {
      alert("Yard no " + response.data.lot_id + " Updated Successfully");
      yield put({
        type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
          .GET_LOTS_DIVISION_MANAGEMENT_API_CALL,
      });
      yield put({
        type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT.EDIT_LOTS_API_SUCCESS,
        payload: { value: response?.callBackStatus },
      });
    } else {
      if (response && response != null && response.Status != 405) {
        alert("Failed to update lot");
        yield put({
          type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT.EDIT_LOTS_API_SUCCESS,
          payload: { value: response?.callBackStatus },
        });
      }
    }
  } catch (e) {
    yield put({
      type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT.EDIT_LOTS_API_SUCCESS,
      payload: { value: "Failed" },
    });
  }
}

const getLotsWithDivisionAPI = () => {
  return APICallingService.sendRequestForGet(
    url.getLotWithDivision,
    (res) => {},
    true
  );
};

function* getLotsWithDivision(action) {
  try {
    let s = store.getState();

    yield put({
      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE,
      payload: { value: true },
    });

    const response = yield call(getLotsWithDivisionAPI);
    if (response && response?.callBackStatus.toLowerCase() == "success") {
      let lotArray = [];

      for (let i = 0; i < response.data.length; i++) {
        if (
          action?.payload?.value != undefined &&
          action?.payload?.value != null &&
          action?.payload?.value != ""
        ) {
          if (response.data[i].division_id == action?.payload?.value) {
            response.data[i].space = [];
            lotArray.push(response.data[i]);
          }
        } else {
          response.data[i].space = [];
          lotArray.push(response.data[i]);
        }
      }

      yield put({
        type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
          .GET_LOTS_DIVISION_MANAGEMENT_API_SUCCESS,
        payload: { value: lotArray },
      });
    } else {
      if (response && response != null && response.Status != 405) {
        alert("Faile to get lots");
        yield put({
          type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
            .GET_LOTS_DIVISION_MANAGEMENT_API_SUCCESS,
          payload: { value: response?.callBackStatus },
        });
      }
    }
  } catch (e) {
    yield put({
      type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
        .GET_LOTS_DIVISION_MANAGEMENT_API_SUCCESS,
      payload: { value: "Failed" },
    });
  }
}

const getLotsByhDivisionAPI = (action) => {
  let lotByDivision = url.getLotByDivision + "/" + action.division_id;

  return APICallingService.sendRequestForGet(lotByDivision, (res) => {}, true);
};

function* getLotsByDivision(action) {
  try {
    let s = store.getState();

    yield put({
      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE,
      payload: { value: true },
    });

    const response = yield call(getLotsByhDivisionAPI, action.payload.value);
    if (response && response?.callBackStatus.toLowerCase() == "success") {
      yield put({
        type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT.GET_LOTS_API_SUCCESS,
        payload: { value: response.data },
      });
    } else {
      if (response && response != null && response.Status != 405) {
        alert("Failed to get lots");
        yield put({
          type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
            .GET_LOTS_BY_DIVISION_MANAGEMENT_API_SUCCESS,
          payload: { value: response?.callBackStatus },
        });
      }
    }
  } catch (e) {
    yield put({
      type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
        .GET_LOTS_BY_DIVISION_MANAGEMENT_API_SUCCESS,
      payload: { value: "Failed" },
    });
  }
}

const getSpaceForLotAPI = (action) => {
  let urlSpace = url.getSpaceWithLotId + "/" + action.payload.value.lot_id;
  return APICallingService.sendRequestForGet(urlSpace, (res) => {}, true);
};

function* getSpaceForLots(action) {
  try {
    let s = store.getState();

    yield put({
      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE,
      payload: { value: true },
    });

    const response = yield call(getSpaceForLotAPI, action);
    if (response && response?.callBackStatus.toLowerCase() == "success") {
      let lotsWithDivision = s.lots.getLotDivisionData;
      let lotSelectedArray = [];
      for (let i = 0; i < lotsWithDivision.length; i++) {
        if (lotsWithDivision[i].lot_id == action.payload.value.lot_id) {
          lotsWithDivision[i].space = response.data;
          lotSelectedArray.push(lotsWithDivision[i]);
        }
      }

      yield put({
        type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
          .GET_LOTS_DIVISION_MANAGEMENT_API_SUCCESS,
        payload: { value: lotsWithDivision },
      });

      yield put({
        type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT.GET_LOTS_SPACE_DATA,
        payload: { value: lotSelectedArray },
      });
      yield put({
        type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT.GET_LOT_SPACE_API_CALLED,
        payload: { value: true },
      });
      yield put({
        type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
          .GET_SPACES_BY_LOTID_MANAGEMENT_API_SUCCESS,
        payload: { value: response.data },
      });
    } else {
      if (response && response != null && response.Status != 405) {
        alert("Failed to get spaces");
        yield put({
          type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
            .GET_SPACES_BY_LOTID_MANAGEMENT_API_SUCCESS,
          payload: { value: response?.callBackStatus },
        });
      }
    }
  } catch (e) {
    yield put({
      type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
        .GET_SPACES_BY_LOTID_MANAGEMENT_API_SUCCESS,
      payload: { value: "Failed" },
    });
  }
}

const getSpaceLogsAPI = (action) => {
  let urlSpaceLog = url.getSpaceLogs + "/" + action.payload.value.space_id;
  return APICallingService.sendRequestForGet(urlSpaceLog, (res) => {}, true);
};

function* getSpaceLogs(action) {
  try {
    let s = store.getState();

    yield put({
      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE,
      payload: { value: true },
    });

    const response = yield call(getSpaceLogsAPI, action);
    if (response && response?.callBackStatus.toLowerCase() == "success") {
      yield put({
        type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
          .GET_SPACELOGS_MANAGEMENT_API_SUCCESS,
        payload: { value: response.data },
      });
    } else {
      if (response && response != null && response.Status != 405) {
        alert("Failed to get space logs");
        yield put({
          type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
            .GET_SPACELOGS_MANAGEMENT_API_SUCCESS,
          payload: { value: response?.callBackStatus },
        });
      }
    }
  } catch (e) {
    yield put({
      type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
        .GET_SPACELOGS_MANAGEMENT_API_SUCCESS,
      payload: { value: "Failed" },
    });
  }
}

export {
  editLots,
  createLots,
  getLots,
  getLotsById,
  getLotsWithDivision,
  getSpaceForLots,
  getSpaceLogs,
  getLotsByDivision,
};
